export default __webpack_public_path__ + "static/media/default-avatar.a8ba6c6a.png";